var exports = {
  "L2": "x43aef4ae--3bd1bb--source-link",
};

module.exports = exports;
